import styled from "styled-components";
import { colors, fontFamily, DEFAULT_BUTTON_COLOR } from "../../styles/Variables";
import { FlexContainer } from "../../styles/common/FlexBox";

export const Coupon = styled.div`
    display: flex;
    width: 100%;
    max-height: 80px;
    border: 1.5px solid lightgray;
    align-items: center;
    justify-content: space-between;
    padding: 20px 15px 20px 00px;
    border-radius: 10px;
    box-shadow: 4px 4px 8px ${colors.shadowLight};
    position: relative; 
    @media (max-width: 768px) {
        flex-direction: column;
        width: 90vw;
        max-height: none;
        justify-content: center;
        gap: 1rem;
    }

    @media (min-width: 769px) and (max-width: 1024px) {
        width: 90vw;
        margin: 0 auto;
    }
    @media (min-width: 1025px) and (max-width: 1114px) {
        max-width: 818px;
        margin-left: 20px;
    }
    
`
export const CouponLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 16px; 

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        gap: 0;
    }
`;
export const CouponImage = styled.img`
    width: 110px;
`
export const CouponCashback = styled.div`
    position: absolute;
    bottom: -22%;
    font-family: ${fontFamily.secondary};
    font-weight: bold;
    color: ${props => props.couponHeaderTextColor};
    @media(max-width: 768px){
        bottom: -19px;
    }
    .text {
        color: inherit; 
        font-weight: bold;
    }
    .hover-text {
        display: none;
        color: #102051;
        text-transform: uppercase;
        font-size: 14px;

    }
    &:hover .text {
        display: none;
    }

    &:hover .hover-text {
        display: inline;
    }
`
export const CouponDescription = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    max-width: 430px;
    width: 100%;
    min-width: 0;
    color: ${colors.black};
    font-size: 13px;
    gap: 8px;

    p {
        display: block;
        font-size: 11px;
        width: 100%;

        @media((min-width: 768px) and (max-width: 890px)){
            max-width: 330px;
            width: 100%;
        }
        @media((min-width: 1024px) and (max-width: 1114px)){
            max-width: 330px;
            width: 100%;
        }
    }

    @media (max-width: 768px) {
        width: auto;
        text-align: center;
        margin-top: 1rem;

        p{
            display: none;
        }
        
    }
`

export const BoxInterno = styled.div`
    vertical-align:middle;
    display:table-cell;
`

export const BotaoCupom = styled.div`
    width: 190px;
    height: 52px;
    color: ${colors.white};
    font-weight: bold;
    font-size: 14px;
    margin-top: 0px;
    font-family: ${fontFamily.secondary};
    display: inline-block;
`

export const BotaoCupomBloco = styled(FlexContainer)`
    position: relative;
    /* right: 16px; */
    max-width: 190px;
    width: 190px;
    height: 100px;
    @media (max-width: 768px) {
        right: 0;
    }
`;

export const BotaoCupomTopo = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    height: 55px;
    background-color: ${props => props.buttonColor};
    font-size: 14px;
    text-transform: uppercase;
    z-index: 2;
    border-radius: 10px;
    line-height: 55px;
    padding-left: 19px;
    text-align: left;
    border-top-right-radius: 2px;
    transition: all 0.125s ease-in-out;
    cursor: pointer;
    &:hover {
        background-color: ${props => props.buttonColorOnHover || props.buttonColor};

        .lock-badge {
            background-color: ${props => props.buttonColorOnHover || props.buttonColor};
        }
    }
`;

export const BotaoCupomFundo = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 170px;
    height: 49px;
    background-color: ${props => props.buttonColorOnHover};
    color: ${props => props.buttonColor};
    border: 3px dashed ${props => props.buttonColor};
    font-size: 17px;
    text-transform: uppercase;
    text-align: right;
    display: table;
    line-height: 49px;
    padding-right: 10px;
    z-index: 1;
    border-radius: 10px;
`;


export const BotaoOferta = styled.div`
    position: absolute;
    cursor: pointer;
    top: 0px;
    height: 55px;
    width: 190px;
    background-color: ${props => props.buttonColor};
    font-size: 14px;
    text-transform: uppercase;
    z-index: 2;
    border-radius: 10px;
    line-height: 55px;
    display: inline-block;
    transition: all .125s ease-in-out;
    text-align: center;
    &:hover {
        background-color: ${(props) => props.buttonColorOnHover || props.buttonColor};
        .lock-badge {
            background-color: ${props => props.buttonColorOnHover || props.buttonColor};
        }
    }
    @media (max-width: 768px) {
        right: 0;
    }
`

export const CouponTittle = styled.h3`
    color: ${colors.primaryColor};
    font-size: 16px;
    font-weight: bold;
    margin: 0 !important;
    text-transform: uppercase;
    width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`

export const LockBadgeWrapper = styled.div`
    position: relative;
    cursor: pointer;
`;

export const LockBadge = styled.div`
    position: absolute;
    top: 50%;
    left: ${({ leftOffset }) => leftOffset || '50%'};
    transform: translate(-50%, -50%);
    width: 34px;
    height: 34px;
    border: 2px dashed white;
    border-radius: 50%;
    background-color: ${({ buttonColor }) => `#${buttonColor}`};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
    z-index: 10;

    @media(max-width: 768px){
        left: ${({ isCouponButton }) => (isCouponButton ? '60%' : '50%')};
    }
`;

export const CouponList = styled.div`
    flex: 2;
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 870px;
    `;

export const HowToUseSection = styled.div`
    flex: 1;
    min-width: 200px;
    max-width: 250px;
    padding: 20px;
    border: 1px solid lightgray;
    border-radius: 10px;
    box-shadow: 4px 4px 8px ${colors.shadowLight};
    background-color: #fff;

    h2 {
        color: ${colors.primaryColor};
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 16px;
        font-family: ${fontFamily.secondary};
    }

    p {
        font-size: 14px;
        color: ${colors.black};
        margin-bottom: 18px;
    }
    @media (min-width: 769px) and (max-width: 1024px) {
        max-width: 400px; 
        margin-bottom: 2rem;
    }
    @media (min-width: 1025px) and (max-width: 1114px) {
        margin-right: 20px;
    }
    @media (max-width: 768px) {
        width: 90%;
        margin-top: 30px;
        margin-bottom: 2rem;

    }
`;
/* ---------- CouponCard (categoria, loja, top cupons e home) ---------- */

export const Card = styled.div`
    display: grid;
    grid-template-columns: 110px auto 1fr auto;
    grid-template-areas:
        "logo title title action"
        "logo desc desc action"
        "logo meta cashback action";
    column-gap: 16px;
    row-gap: 6px;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    border: 1.5px solid lightgray;
    border-radius: 10px;
    box-shadow: 4px 4px 8px ${colors.shadowLight};
    background-color: ${colors.white};
    position: relative;

    @media (min-width: 769px) and (max-width: 1024px) {
        width: 90vw;
        margin: 0 auto;
    }
    @media (min-width: 1025px) and (max-width: 1114px) {
        max-width: 818px;
        margin-left: 20px;
    }

    @media (max-width: 768px) {
        width: 90vw;
        grid-template-columns: 1fr;
        grid-template-areas:
            "logo"
            "cashback"
            "title"
            "meta"
            "action";
        justify-items: center;
        text-align: center;
        row-gap: 6px;
        padding: 14px;
    }
`;

export const CardLogo = styled.img`
    grid-area: logo;
    width: 110px;
    max-height: 80px;
    object-fit: contain;
    justify-self: center;
    align-self: center;

    @media (max-width: 768px) {
        width: 120px;
        height: 72px;
        max-height: none;
    }
`;

export const CashbackChip = styled.span`
    grid-area: cashback;
    justify-self: start;
    display: inline-flex;
    align-items: center;
    width: fit-content;
    padding: 2px 8px;
    border-radius: 999px;
    color: ${DEFAULT_BUTTON_COLOR};
    background-color: #eaf4fb;
    border: 1px solid ${DEFAULT_BUTTON_COLOR}33;
    font-family: ${fontFamily.secondary};
    font-size: 12px;
    font-weight: bold;
    white-space: nowrap;

    @media (max-width: 768px) {
        justify-self: center;
    }
`;

export const CardTitle = styled.h3`
    grid-area: title;
    margin: 0 !important;
    min-width: 0;
    color: ${colors.primaryColor};
    font-size: 16px;
    font-weight: bold;
    line-height: 1.3;
    text-align: left;
    text-transform: ${props => (props.$uppercase ? 'uppercase' : 'none')};
    overflow-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    @media (max-width: 768px) {
        width: 100%;
        font-size: 15px;
        text-align: center;
        text-transform: none;
    }
`;

export const CardDescription = styled.p`
    grid-area: desc;
    margin: 0;
    min-width: 0;
    color: ${colors.black};
    font-size: 12px;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const CardMeta = styled.div`
    grid-area: meta;
    display: flex;
    align-items: center;
    gap: 4px;
    color: #555555;
    font-size: 12px;
    white-space: nowrap;

    @media (max-width: 768px) {
        justify-content: center;
    }
`;

export const CardAction = styled.div`
    grid-area: action;
    align-self: center;

    /* No mobile o botão fica centralizado, no tamanho original, sem espaço morto abaixo */
    @media (max-width: 768px) {
        justify-self: center;

        ${BotaoCupom},
        ${BotaoCupomBloco} {
            height: 55px;
        }
    }
`;

export const ContainerHowToUse = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 50px;
    max-width: 1170px;
    margin: auto;

    @media (max-width: 1024px) {
        gap: 10px;
        flex-direction: column;
        align-items: center;
    }
`;